var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-activity',{attrs:{"value":_vm.itemRevision}})
}
var staticRenderFns = []

export { render, staticRenderFns }